import { SVGProps } from 'react';

const NearFullStar = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      d="m1.243 5.51 4.253-.617L7.398 1.04a.667.667 0 0 1 1.196 0l1.902 3.853 1.004.146 1.056 4.103-.52.505.728 4.237a.667.667 0 0 1-.902.733l-.066-.03-3.796-2-3.804 2a.667.667 0 0 1-.976-.63l.009-.073.726-4.237-3.08-2.999a.667.667 0 0 1 .292-1.123z"
      clipRule="evenodd"
    />
    <path
      fill={fill}
      d="M7.996.668a.67.67 0 0 1 .598.372l1.901 3.854 4.254.617a.666.666 0 0 1 .563.763l-.019.085a.7.7 0 0 1-.122.232l-.052.057-3.083 3 .728 4.236.009.088a.7.7 0 0 1-.042.26l-.036.08a.7.7 0 0 1-.167.202l-.073.052a.7.7 0 0 1-.246.09l-.088.007a.7.7 0 0 1-.174-.018l-.084-.028-.067-.03-3.796-2-3.804 2-.08.035a.7.7 0 0 1-.26.041l-.087-.01a.7.7 0 0 1-.167-.053l-.077-.043a.67.67 0 0 1-.305-.6l.009-.073.726-4.236-3.08-3a.668.668 0 0 1 .21-1.094l.083-.029.075-.015 4.253-.616L7.4 1.04a.67.67 0 0 1 .597-.372m-1.782 4.58a.8.8 0 0 1-.602.437l-3.986.578 2.888 2.811a.8.8 0 0 1 .23.708l-.681 3.971 3.565-1.874.09-.041a.8.8 0 0 1 .655.041l3.556 1.873-.68-3.97a.8.8 0 0 1 .23-.708l2.887-2.81-3.985-.58a.8.8 0 0 1-.602-.437L7.996 1.635z"
    />
  </svg>
);

export default NearFullStar;
